<template>
  <div>
    <BackgroundBubbles />
    <button class="absolute top-5 right-5 button-bkk-100" @click="logout">
      {{ $t("profile.screen.account.section.logout.tile") }}
    </button>
    <div
      class="m-auto h-screen max-w-7xl flex justify-center align-middle flex-col p-5"
    >
      <div class="text-4xl mx-auto mb-8">
        {{ $t("error.maintenance.title") }}
      </div>
      <div class="text-xl mx-auto">
        {{ $t("error.maintenance.text") }}
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundBubbles from "../../components/v2/layout/BackgroundBubbles.vue";

export default {
  name: "MaintenancePage",
  components: { BackgroundBubbles },
  methods: {
    logout() {
      this.$userAuthenticator.logout();
    },
  },
};
</script>
